import { render, staticRenderFns } from "./CustomizeFolderModal.vue?vue&type=template&id=3c6b5578&scoped=true"
import script from "./CustomizeFolderModal.vue?vue&type=script&lang=js"
export * from "./CustomizeFolderModal.vue?vue&type=script&lang=js"
import style0 from "./CustomizeFolderModal.vue?vue&type=style&index=0&id=3c6b5578&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6b5578",
  null
  
)

export default component.exports